import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomOutlet } from '@/components/functional/Link/CustomOutlet';
import { HotlineProDetailDataContextProvider } from '@/feature/hotline/professional/detail/context/HotlineProDetailDataContext';
/**
 * 匿名ホットライン詳細 共通レイアウト
 * @description /hotline/professional/:id/ 配下に適用
 */
export const HotlineProDetailLayout = () => (_jsx(HotlineProDetailDataContextProvider, { children: _jsx(CustomOutlet, {}) }));
